export var logWarning = function logWarning(videoSource) {
  console.error("Warning:  `Video.props.videoSource` must be a valid URL or valid HTML. Received: ".concat(videoSource));
};